import React, { useEffect, useState } from "react";
import { FlameIcon } from "lucide-react";
const TOTAL = 100;
export function ScarcityBar() {
  const [left, setLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(l => l > 3 ? l - 1 : l);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL - left) / TOTAL * 100;
  return <div className="w-full max-w-xl rounded-2xl border border-danger/25 bg-danger-soft p-4" data-id="element-248" data-mp="2b68kbs06s0i6">
      <div className="flex items-center justify-between gap-3 text-sm" data-id="element-249" data-mp="2g6cqop7dreuo">
        <p className="flex items-center gap-1.5 font-bold text-danger" data-id="element-250" data-mp="2g3gup6f3f08v">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-251" data-mp="227mxhknolzbl" />
          Only {left} spots left at $27
        </p>
        <span className="font-semibold tabular-nums text-ink/70" data-id="element-252" data-mp="27797ll87qzg6">{Math.round(filled)}% claimed</span>
      </div>
      <div className="mt-2.5 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-253" data-mp="cuo0mpo20sd">
        <div className="bar-stripes h-full rounded-full bg-danger transition-[width] duration-300 ease-out" style={{
        width: `${filled}%`
      }} data-id="element-254" data-mp="2zl9qypmukgrb" />
      </div>
      <p className="mt-2 text-xs text-ink/65" data-id="element-255" data-mp="3dc6ei21x27ri">When these spots are gone, the promotional price closes.</p>
    </div>;
}